module.exports = __webpack_public_path__ + "static/media/ride-of-lifetime.72891e1f.jpg";